import { disaggregations } from '../../../../common/utils/enum'
import {
  formatValues,
  formatNumberOnUnitMeasure,
  getBadges,
  getNameFromDisaggregation,
  getRecentYearRange,
} from '../../../../common/utils/helper'
import { COLOR_MAP } from '../../../../common/utils/theme'
import { getSingleYearChartSubtitle } from '../../common/helper'

export const generateBeeswarmChartData = (
  indicatorDataForChart,
  indicatorMetadata,
  countriesData,
  selectedCountries,
  selectedYear,
  selectedComparison,
  selectedFilters,
  recentYearSelection,
  disaggregationData,
  filteredAggregateData,
  unitMeasureName,
  site,
  selectedOnlyShow,
  regionHierarchy,
  incomeGroupHierarchy
) => {
  if (indicatorDataForChart && countriesData && selectedCountries) {
    const beeswarmData = []

    const isOnlyShowIncomeGroup =
      incomeGroupHierarchy
        ?.map((group) => group.id)
        ?.includes(selectedOnlyShow) || false
    const regionIncomeGroupCountriesMapping = isOnlyShowIncomeGroup
      ? incomeGroupHierarchy
      : regionHierarchy
    regionIncomeGroupCountriesMapping.forEach((group) => {
      group.countries.forEach((country) => {
        const countryCode = country.id
        const countryName = country.name

        const data = indicatorDataForChart.find(
          (item) => item[disaggregations.RefArea] === countryCode
        )

        let xYear = data?.data?.xAxis?.[0]
        let xValue = data?.data?.yAxis?.[0]

        if (xValue) {
          beeswarmData.push({
            value:
              xValue === 'null' || xValue === 'NaN'
                ? null
                : formatValues(xValue),
            year: xYear,
            country: countryName,
            selectedCountry: selectedCountries?.includes(countryCode),
            color: COLOR_MAP[group.id],
            // region: group.id, // getNameFromCodelist(codelist, 'REF_AREA', region.id),  //to be uncommented if region name is needed
            unitMult: data?.[disaggregations.UnitMult] ?? null,
            decimals: data?.[disaggregations.Decimals] ?? null,
            unitMeasure: data?.[disaggregations.UnitMeasure],
          })
        }
      })
    })
    const aggregateData = filteredAggregateData.map((item) => {
      let value = item?.data?.yAxis?.[0]

      value =
        value && value !== 'null' && value !== 'NaN'
          ? formatValues(value)
          : null
      return {
        value,
        label: `${getNameFromDisaggregation(
          disaggregationData?.dimensions,
          disaggregations.RefArea,
          item[disaggregations.RefArea]
        )?.toUpperCase()} ${formatNumberOnUnitMeasure({
          value,
          unitMeasure: item?.[disaggregations.UnitMeasure],
          decimals: item?.[disaggregations.Decimals],
          isCommaSeparatedFormat: true,
        })}`,
      }
    })

    const title =
      indicatorMetadata?.admin_metadata?.[site]?.visualization?.display_name ||
      indicatorMetadata?.series_description.name

    const subtitle = getSingleYearChartSubtitle(
      selectedCountries,
      countriesData,
      recentYearSelection
        ? `Most recent values ${getRecentYearRange(indicatorDataForChart)}`
        : selectedYear
    )

    return {
      data: beeswarmData,
      aggregateData,
      title,
      subtitle,
      badges: getBadges(
        selectedFilters,
        disaggregationData,
        selectedComparison,
        unitMeasureName
      ),
      indicatorMetadata,
    }
  }
}
